import { Crosshair, Inbox, type LucideIcon } from 'lucide-react';
import type { IconType } from 'react-icons';
import { WORKFLOW_STAGE_ICONS } from '~/components/WorkflowStages';
import type { CourseStage } from '../model';

/**
 * Glyph of each course stage. A stage that leads into a workflow wears that
 * workflow's glyph, so the list and the viewer's step rail draw the same work
 * the same way; Received leads into none and gets its own. The two contouring
 * stages lead into the same workflow but are different work, so target
 * contouring is told apart from organ-at-risk contouring.
 */
export const COURSE_STAGE_ICONS: Record<CourseStage, LucideIcon | IconType> = {
    Received: Inbox,
    ImagePreparation: WORKFLOW_STAGE_ICONS.setup,
    ImageRegistration: WORKFLOW_STAGE_ICONS.imageRegistration,
    OarContouring: WORKFLOW_STAGE_ICONS.contouring,
    TargetContouring: Crosshair,
    DosePrediction: WORKFLOW_STAGE_ICONS.dosePlanning,
    Review: WORKFLOW_STAGE_ICONS.review,
    Exported: WORKFLOW_STAGE_ICONS.export,
};
